class NewProductsNavController {
    constructor(newProductsService) {
        this.newProducts = newProductsService;
    }
}

NewProductsNavController.$inject = ['NewProductsService'];

const newProductsNavComponentDefinition = {
    controller: NewProductsNavController,
    template: require('./newproducts-navigation.component.html').trim(),
};

module.exports = {
    NewProductsNavController,
    newProductsNavComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/newproducts/newproducts-navigation.component.js